import { Avatar } from "@/elements"

export const NotificationSkeleton: React.FC = () => {
  return (
    <div className={"flex flex-row w-full p-2 rounded-md items-center"}>
      <div className={"flex flex-row w-full items-center"}>
        <div className="pr-3">
          <Avatar src="" initials="" size="sm" loading />
        </div>
        <div className="flex flex-col flex-grow justify-center">
          <div className="w-4/5 h-[16px] bg-bg-2 rounded mb-1 animate-pulse"></div>
          <div className="w-1/2 h-[16px] bg-bg-2 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  )
}
